module.exports = __webpack_public_path__ + "d644f8013d79d3c72aee3f45eda26d4f.svg";